import React, { useState } from 'react';
import { useEffect } from 'react';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CustomDatePicker from '../components/CustomDatePicker';
import InputWrapper from '../components/InputWrapper';
import Overlay from '../components/Overlay';
import { useDMSContext } from '../context/DMSContext';
import contractService from '../services/ContractService';
import settlementService from '../services/SettlementService';
import MyButton from '../UI/button/MyButton';
import Card from '../UI/Card/Card';
import MySelect from '../UI/select/MySelect';
import GenericTable from '../UI/table/GenericTable';
import { contractStatuses, currencies, paysFrequency, settlementOptions } from '../assets/data/option'
import { format } from 'date-fns';

export default function ContractDetailsPage() {
  const { id } = useParams();
  const { getContractById, refetchContracts, debtors, settings, refetchDebtors } = useDMSContext();
  const [contract, setContract] = useState(getContractById(id));
  const [isEditing, setIsEditing] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [isSettlementEditing, setIsSettlementEditing] = useState(false);
  const [settlements, setSettlements] = useState([]);
  const [settlement, setSettlement] = useState({
    name: "",
    amount: "",
    executionDate: null,
    type: "DEBIT",         
  })

  const fetchSettlements = async () => {
    try {
      const data = await settlementService.getSettlements(id);
      setSettlements(data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchSettlements();
  }, [])
  

  const handleContractSave = async () => {
    try {
      const response = await contractService.updateContract(contract.id, contract);
      refetchContracts();
      refetchDebtors();
      toast.success('Contractul a fost actualizat cu succes');
    } catch (error) {
      toast.error('Eroare la actualizarea contractului');
    }finally{
      setIsEditing(false);
    }
  }
  const handleChange = (field, value) => {
    setContract(prev => ({ ...prev, [field]: value }));
  };

  const handleOverlay = () => {
      setOverlay(!overlay);
  }

  const handleEditSettlement = (settlementData) => {
      setSettlement(settlementData);
      setIsSettlementEditing(true);
      setOverlay(true);
  };

  const submitSettlement = async (e) => {
    e.preventDefault();
    
    if (isSettlementEditing) {
      try {
        const response = await settlementService.updateSettlement(settlement.id, settlement);
        fetchSettlements();
        toast.success('Decontarea a fost actualizată cu succes');
      } catch (error) {
        toast.error('Eroare la actualizarea decontării');
      }
    } else {
      try {
        const response = await settlementService.addSettlement(contract.id, settlement);
        fetchSettlements();
        toast.success('Decontarea a fost adăugată cu succes');
      } catch (error) {
        toast.error('Eroare la adăugarea decontării');
      }
    }

    setSettlement({
      name: "",
      amount: "",
      executionDate: null,
      type: "DEBIT",
    })

    setIsEditing(false);
    setOverlay(false);
  }

  const deleteSettlement = async (settlementId) => {
    try {
      const response = await settlementService.deleteSettlement(settlementId);
      fetchSettlements();
      toast.success('Decontarea a fost ștearsă cu succes');
    } catch (error) {
      toast.error('Eroare la ștergerea decontării');    
    }
  }

  const settlementColumns = [
    {
      Header: 'DATA',
      accessor: 'executionDate',
      Cell: ({ value }) => {
        try {
          const date = new Date(value);
          return isNaN(date) ? '' : format(date, 'dd.MM.yyyy');
        } catch {
          return '';
        }
      }
    },
    { Header: 'DOCUMENT', accessor: 'name' },
    {
      id: 'credit',
      Header: 'CREDIT',
      accessor: 'amount',
      Cell: ({ row }) => {
        const { amount, type, currency } = row.original;
        return type == 'CREDIT' && <span>{parseFloat(amount).toFixed(2)} {currency}</span>;
      }
    },
    {
        id: 'debit',
        Header: 'DEBIT',
        accessor: 'amount',
        Cell: ({ row }) => {
          const { amount, type, currency } = row.original;
          return type == 'DEBIT' && <span>{parseFloat(amount).toFixed(2)} {currency}</span>;
        }
      },
    {
        Header: 'ACȚIUNI',
        enableCellClick: false,
        Cell: ({ row }) => (
          <div className="actions">
            <button className="edit" onClick={(e) => {e.stopPropagation();handleEditSettlement(row.original)}}>
              <FaEdit />
            </button>
            <button className="delete" onClick={(e) => {e.stopPropagation();deleteSettlement(row.original.id)}}>
              <FaTrash />
            </button>
          </div>
        )
      }      
  ];

  return (
    <div className='dms-content'>
      <Card>
      
      <div className='contract-section'>
     <div style={{display:"flex", justifyContent:"space-between"}}>
     <h3 style={{alignSelf:"center"}}>{contract.name}</h3>
      {isEditing && (
            <div className="form-actions">
                <MyButton
                body="Renunță"
                onClick={() => {
                    setContract(getContractById(id));
                    setIsEditing(false);
                }}
                style={{ maxWidth: '175px', color: 'var(--prolex-red)', borderColor: 'var(--prolex-red)' }}
                />
                <MyButton
                body="Salvează"
                onClick={handleContractSave}
                style={{ maxWidth: '245px', color: 'var(--prolex-blue)', borderColor: 'var(--prolex-blue)' }}
                type="submit"
                />
            </div>
            )}

            {!isEditing && (
            <div className="form-actions">
                <MyButton
                body="Editează"
                onClick={() => setIsEditing(true)}
                style={{ maxWidth: '200px' }}
                />
            </div>
            )}
     </div>
        <form className='contract-details-grid'>
        <div className='form-row'>
          <h3 className="section-subtitle">Date Contractuale</h3>
           <InputWrapper
                body="Număr/Denumire Contract"
                value={contract.name}
                onChange={(e) => handleChange('name', e.target.value)}
                disabled={!isEditing}
                isRequired
            />

            <div className='myInpWrapper'>
                <label className='myInpLabel'>Data Încheierii <span style={{ color: 'red' }}>*</span></label>
                <CustomDatePicker
                value={contract.startDate}
                onChange={(date) => handleChange('startDate', date)}
                disabled={!isEditing}
                />
            </div>

            <div className='myInpWrapper'>
                <label className='myInpLabel'>Data Obligațiunii <span style={{ color: 'red' }}>*</span></label>
                <CustomDatePicker
                value={contract.obligationDate}
                onChange={(date) => handleChange('obligationDate', date)}
                disabled={!isEditing}
                />
            </div>

            <div className='myInpWrapper'>
                <label className='myInpLabel'>Finalizarea Contractului <span style={{ color: 'red' }}>*</span></label>
                <CustomDatePicker
                value={contract.endDate}
                onChange={(date) => handleChange('endDate', date)}
                disabled={!isEditing}
                />
            </div>
           </div>

        <div className='form-row'>
          <h3 className="section-subtitle">Valori Financiare</h3>
            <InputWrapper
                body="Valoarea Totală a Contractului"
                value={contract.value}
                onChange={(e) => handleChange('value', e.target.value)}
                disabled={!isEditing}
                isNumeric
                isRequired
            />

            <div className='myInpWrapper'>
                <label className='myInpLabel'>Valuta</label>
                <MySelect
                options={currencies}
                value={currencies.find(option => option.value == contract.currency)}
                disabled={!isEditing}
                onChange={(selectedOption) => handleChange('currency', selectedOption || '')}
                />
            </div>

            <InputWrapper
                body="Procent Penalitate Zilnică (%)"
                value={contract.penaltyPercentPerDay}
                onChange={(e) => handleChange('penaltyPercentPerDay', e.target.value)}
                disabled={!isEditing}
                isNumeric
            />

            <div className='myInpWrapper'>
                <label className='myInpLabel'>Frecvența Plăților</label>
                <MySelect
                options={paysFrequency}
                value={paysFrequency.find(option => option.value === contract.payFrequency)}
                disabled={!isEditing}
                onChange={(selectedOption) => handleChange('payFrequency', selectedOption || '')}
                />
            </div>

            <InputWrapper
                body="Suma Inițială Datorată"
                value={contract.initialDue}
                onChange={(e) => handleChange('initialDue', e.target.value)}
                disabled={!isEditing}
                isNumeric
                isRequired
            />
            </div>
            <div className='form-row'>
            <h3 className="section-subtitle">Setări</h3>
            <div className='myInpWrapper'>
              <label className='myInpLabel'>Debitor <span style={{ color: 'red' }}>*</span></label>
              <MySelect
                options={[{ value: 0, label: ' --Selectează debitorul-- ' }, ...debtors.map(d => ({ value: d.id, label: d.name }))]}
                value={[{ value: 0, label: ' --Selectează debitorul-- ' }, ...debtors.map(d => ({ value: d.id, label: d.name }))].find(
                  option => option.value === contract.debtorId
                )}
                disabled={!isEditing}
                onChange={(selectedOption) => handleChange('debtorId', selectedOption || '')}
              />
            </div>

            <div className='myInpWrapper'>
              <label className='myInpLabel'>Status Contract</label>
              <MySelect
                options={contractStatuses}
                value={contractStatuses.find(option => option.value === contract.status)}
                disabled={!isEditing}
                onChange={(selectedOption) => handleChange('status', selectedOption || '')}
              />
            </div>
            </div>
        </form>
            </div>
      </Card>
      <Card>
      <div style={{display:"flex", justifyContent:"space-between", marginBottom:"1rem"}}>
      <h3 style={{alignSelf:"center"}}>Istoric Decontări</h3>
      <MyButton
        style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
        id="addSettlementBtn"
        body={<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}><FaPlus/>Adaugă Decontare Nouă</span>}
        type="button"
        onClick={handleOverlay}
        />
      </div>
      <GenericTable data={settlements} columns={settlementColumns}/>
      </Card>
      <Overlay
                handleOverlay={handleOverlay}
                isOpen={overlay}
                maxWidth="55vw"
      >
        <h2 style={{marginBottom:"2rem"}}>Adaugă Decontare Nouă</h2>
        <form onSubmit={submitSettlement} className='form-container'>
          <InputWrapper
            isRequired={true}
            value={settlement.name}
            onChange={(e) => setSettlement(prev => ({...prev, name:e.target.value}))}
            type="text"
            name='settlementName'
            body={<>Nume <span style={{color:"red"}}>*</span></>}
            />
          <div className='myInpWrapper'>
            <label htmlFor="datepicker2" className='myInpLabel'>Data decontării<span style={{color:"red"}}>*</span></label>
              <CustomDatePicker
                value={settlement.executionDate} 
                onChange={(date) => {setSettlement(prev => ({ ...prev, executionDate: date }));}} 
                name="datepicker2"
                isRequired={true}
                />
          </div>
          <InputWrapper
            value={settlement.amount}
            onChange={(e) => setSettlement(prev => ({...prev, amount:e.target.value}))}
            type="text"
            name='settlementAmount'
            body={<>Suma <span style={{color:"red"}}>*</span></>}
            isNumeric={true}
            isRequired={true}
          />
          <div className='myInpWrapper'>
            <label htmlFor={"debtors"} className={'myInpLabel'}>Tip</label>
              <MySelect 
                options={settlementOptions}
                name="settlementOptions"
                value={settlementOptions.find(option => option.value === settlement.type)}
                onChange={(selectedOption) => setSettlement(prev => ({ ...prev, type: selectedOption || '' }))}
                />
          </div>
          <div className='flex-row' style={{justifyContent:"flex-end"}}>
            <MyButton
              style={{maxWidth:"175px",color:"var(--prolex-red)",borderColor:"var(--prolex-red)"}}
              id="cancelBtn"
              body="Anulează"
              onClick={handleOverlay}
            />
            <MyButton
              style={{maxWidth:"245px",color:"var(--prolex-blue)",borderColor:"var(--prolex-blue)"}}
              id="addSettlementBtn"
              body={<>Salvează Decontare</>}
              type='submit'
            />
          </div>       
        </form>
      </Overlay>
    </div>
  );
}
